module.exports = __webpack_public_path__ + "static/media/13.de5c9c3f.jpg";